import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import CardHeader from '../../../../components/CardHeader';
import Toast from '../../../../components/Toast';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { dataService } from '../../../../services/data.services';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { downloadS3Object } from '../../../../CommonMethods/S3DownloadHook';
import { formatNoticeTypeLabel } from '../noticeTypeUtils';
import { formatAdjustedDate, formatDateTime } from '../../../../CommonMethods/formatDate';

export default function ViewUpdate() {
    const { id } = useParams();
    const location = useLocation();
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const [notice, setNotice] = useState(null);

    useEffect(() => {
        const loadNotice = async () => {
            try {
                const branch_id = await GetBranchId();
                const res = await dataService.GetAPI(`notice-board/updates/${id}?branch_id=${branch_id}`);
                setNotice(res.data?.data?.data || res.data?.data || null);
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || 'Something went wrong while loading');
            } finally {
                setPageLoading(false);
            }
        };

        loadNotice();
    }, [id]);

    const handleAttachmentDownload = async (attachment) => {
        if (!attachment?.key) return;
        try {
            await downloadS3Object(attachment.key);
        } catch {
            setToastErrorMessage('Unable to download attachment');
        }
    };

    const sectionDisplay = notice?.sections?.length > 0
        ? notice.sections.map((section) => section.section_name).join(', ')
        : notice?.section_name || '-';
    const receiverDisplay = notice?.receiver_type === 'student'
        ? `${notice?.student_name || '-'}${notice?.student_number ? ` (${notice.student_number})` : ''}`
        : sectionDisplay;
    const backLocation = location.search
        ? `/noticeboard/classroom${location.search}`
        : '/noticeboard/classroom?type=updates';

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="View Update"
                isback={true}
                backLocation={backLocation}
            />
            {toastErrorMessage !== '' && (
                <Toast message={toastErrorMessage} type="error" setToastmessage={setToastErrorMessage} />
            )}
            {pageLoading && (
                <CustomOverLay Active text="Loading..." classKey="flex flex-col 
                justify-center items-center sidebarOpenedOverlay" />
            )}
            {!pageLoading && (
                <div className="mainDataCntnrPageDiv scrollBlue_thick">
                    <div className="2xl:w-[65%] w-[80%] mx-auto">
                        <div className="border rounded border-[#D0D5DD]  p-3 mb-6 2xl:w-[70%] xl:w-[85%] m-auto bg-white">
                            <div className="-mx-2 flex w-full">
                                <div className="w-[50%] px-2 " >
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[110px]" >Academic Year</span>
                                        <span className="font-semibold break-all">{notice?.academic_year_name}</span>
                                    </div>
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[110px]" >Class</span>
                                        <span className="font-semibold break-all">{notice?.class_name}</span>
                                    </div>
                                    <div className="flex gap-4">
                                        <span className="w-[110px]" >Section</span>
                                        <span className="font-semibold break-all">{sectionDisplay}</span>
                                    </div>
                                </div>
                                <div className="w-[50%] px-2 " >
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[90px]" >Type</span>
                                        <span className="font-semibold break-all">
                                            {notice?.notice_type_label || formatNoticeTypeLabel(notice?.notice_type)}</span>
                                    </div>
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[90px]" >Added Date</span>
                                        <span className="font-semibold break-all">
                                            {formatDateTime(notice?.created_at) || '-'} </span>
                                    </div>
                                    <div className="flex gap-4">
                                        <span className="w-[90px]" >Added by</span>
                                        <span className="font-semibold break-all">{notice?.created_by_name || '-'}</span>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="border border-[#D0D5DD] p-3 rounded mt-4">
                            <div className="flex items-start mb-4">
                                <p className="min-w-[130px]">Receiver</p>
                                <p className=" font-semibold ">{receiverDisplay || '-'}</p>
                            </div>

                            <div className="flex items-start mb-4">
                                <p className="min-w-[130px]">Title</p>
                                <p className=" font-semibold w-full">{notice?.title || '-'}</p>
                            </div>

                            <div className="flex items-start mb-4">
                                <p className="min-w-[130px]">Description</p>
                                <p className=" w-full whitespace-pre-wrap">
                                    {notice?.description || '-'}</p>
                            </div>

                            <div className="flex items-start">
                                <p className="min-w-[130px]">Attachments</p>
                                <div className="w-full">
                                    {(notice?.attachments || []).length > 0 ? (
                                        notice.attachments.map((att, index) => (
                                            <div key={`${att.key}-${index}`} className="flex items-center gap-2 mb-2">
                                                <button
                                                    type="button"
                                                    className="text-[#106EB4] underline text-left"
                                                    onClick={() => handleAttachmentDownload(att)}
                                                >
                                                    {att.name}
                                                </button>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="">-</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </CardHeader>
    );
}
